import React, { useEffect, useState } from 'react';
import { Box, MenuItem, Select, TextField, Typography, IconButton } from '@mui/material';
import DownloadingOutlinedIcon from '@mui/icons-material/DownloadingOutlined';
import './StaffStudyDocument.css';
import Swal from 'sweetalert2';
import axios from 'axios';

const StaffFileUploadComponent = ({ urls, _id, getData, setGetData, setShowSpinner }) => {
  const [file, setFile] = useState(null);
  const [fileType, setFileType] = useState('');
  const [documents, setDocuments] = useState([]);

  // Update documents state when urls prop changes
  useEffect(() => {
    setDocuments(urls);
  }, [urls]);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleTypeChange = (e) => {
    setFileType(e.target.value);
  };

  const handleUpload = () => {
    setShowSpinner(true);
    //Bearer Token
    const token = localStorage.getItem('token');
    const tokenValue = token ? token.slice(1, token.length - 1) : "";
    if (file && fileType) {
      const newDocument = {
        name: file.name,
        type: fileType,
        file: file,
        url: URL.createObjectURL(file)
      };
      if (newDocument.file.type === 'application/pdf') {
        setFile(null);
        setFileType('');
        //Uploading Document
        handleSubmit(_id, tokenValue, fileType, file)
      } else {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: 'File should be a pdf',
          customClass: {
            container: 'swal2-container-custom'
          }
        })
          .then(() => {
            setShowSpinner(false);
          })
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: 'File or file type missing',
        customClass: {
          container: 'swal2-container-custom'
        }
      })
        .then(() => {
          setShowSpinner(false);
        })
    }
  };

  const handleSubmit = async (_id, token, name, file) => {
    setShowSpinner(true);
    // Assuming 'cvFile', 'mlFile', 'gcFile' are the file objects obtained from the input elements
    const formData = new FormData();
    formData.append(name, file);

    // URL for uploading documents
    const uploadUrl = `https://research-mate-b35a10757d5a.herokuapp.com/api/staff/uploadSingleDocument?name=${_id}&folder=${name}`;

    // Make the API request to upload documents
    axios.post(uploadUrl, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${token}`
      }
    })
      .then(res => {
        setGetData(!getData);
        setFile(null)
        Swal.fire({
          title: "Uploaded!",
          text: "Your document has been uploaded",
          icon: "success",
          customClass: {
            container: 'swal2-container-custom'
          }
        });
      })
      .catch(error => {
        // Handle error
        console.log("Error:", error);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.response?.data?.message || error.message,
          customClass: {
            container: 'swal2-container-custom'
          }
        });
      })
      .finally(() => {
        setShowSpinner(false);
      })
  };

  const handleDocumentClick = (document) => {
    window.open(document, '_blank');
  };

  return (
    <Box sx={{ p: 4 }}>
      <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
        <TextField
          type="file"
          onChange={handleFileChange}
          variant="outlined"
          fullWidth
        />
        <Select
          value={fileType}
          onChange={handleTypeChange}
          variant="outlined"
          displayEmpty
          fullWidth
        >
          <MenuItem value="" disabled>
            Select Type
          </MenuItem>
          <MenuItem value="cv">CV</MenuItem>
          <MenuItem value="ml">Ml</MenuItem>
          <MenuItem value="gc">GC</MenuItem>

        </Select>
        <IconButton variant="outlined" onClick={handleUpload} sx={{ bgcolor: '#169a8f', '& .MuiSvgIcon-root': { fontSize: '2.5rem' } }}>
          <DownloadingOutlinedIcon />
        </IconButton>
      </Box>
      <Box>
        <div>

        <Box className="d-flex w-100 justify-content-start align-items-center">
            {documents.map((doc, index) => {
              return (
                < Box
                  key={index}
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mx: 1,
                    p: 2,
                    borderRadius: '4px',
                    width:'300px',
                    height:'50px',
                    boxShadow: 'rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset',
                    cursor: 'pointer',
                  }}
                  onClick={() => handleDocumentClick(doc)}
                >
                  <h4 style={{color:'rgb(23 131 131)', textTransform: 'uppercase'}}>{doc.split("/")[doc.split("/").length - 2]}</h4>
                  <h4 style={{color:'rgb(23 131 131)',cursor:'pointer'}}> <DownloadingOutlinedIcon /></h4>
                  {/* <Typography variant='h4' sx={{ color: 'rgb(22 154 143)' }}>
                    Document
                  </Typography>
                  <Typography variant='h4' sx={{ color: 'rgb(22 154 143)' }}>
                    {doc.split("/")[doc.split("/").length - 2]}
                  </Typography> */}
                </Box>
              )
            })}
          </Box>
        </div>
      </Box >
    </Box >
  );
};

export default StaffFileUploadComponent;
